
import { PageContainer } from "@/components/layout/PageContainer";
import { Book, Video, FileText, Newspaper } from "lucide-react";
import { ResourceCard } from "@/components/resources/ResourceCard";
import { ResourceHeader } from "@/components/resources/ResourceHeader";
import { Helmet } from "react-helmet";

export default function Resources() {
  const resourceSections = [
    {
      title: "White Papers & Research",
      description: "Access our comprehensive research papers, studies, and technical documentation.",
      icon: Book,
      links: [
        "Research Papers",
        "Technical Documentation",
        "Clinical Studies",
        "Implementation Guides"
      ],
      path: "/resources/white-papers-research"
    },
    {
      title: "Webinars & Demos",
      description: "Watch our webinars and product demonstrations for in-depth learning.",
      icon: Video,
      links: [
        "Product Demos",
        "Webinar Recordings",
        "Training Sessions",
        "Interactive Tutorials"
      ],
      path: "/resources/webinars-demos"
    },
    {
      title: "Case Studies",
      description: "Explore our case studies and learn from real-world examples.",
      icon: FileText,
      links: [
        "Success Stories",
        "Implementation Examples",
        "Outcome Data",
        "Care Strategies"
      ],
      path: "/resources/case-studies"
    },
    {
      title: "Blog & News",
      description: "Read our blog posts for insights, tips, and industry updates.",
      icon: Newspaper,
      links: [
        "Latest Updates",
        "Industry Insights",
        "Research Papers",
        "Newsletters"
      ],
      path: "/resources/blog-news"
    },
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://scienzahealth.com/resources#webpage",
    "url": "https://scienzahealth.com/resources",
    "name": "Scienza Health Resources - Knowledge Base, Tutorials, and Support",
    "description": "Access comprehensive resources including knowledge base, video tutorials, case studies, and educational content for cognitive health monitoring.",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Scienza Health",
      "@id": "https://scienzahealth.com/#website"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://scienzahealth.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Resources",
          "item": "https://scienzahealth.com/resources"
        }
      ]
    },
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": resourceSections.map((section, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": section.title,
        "description": section.description,
        "url": `https://scienzahealth.com${section.path}`
      }))
    }
  };

  return (
    <>
      <Helmet>
        <title>Scienza Health Resources - Knowledge Base, Tutorials, and Support</title>
        <meta name="description" content="Access comprehensive resources including knowledge base, video tutorials, case studies, and educational content for cognitive health monitoring." />
        <link rel="canonical" href="https://scienzahealth.com/resources" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <PageContainer>
        <div className="max-w-6xl mx-auto">
          <ResourceHeader />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {resourceSections.map((section, index) => (
              <ResourceCard
                key={section.title}
                {...section}
                index={index}
              />
            ))}
          </div>
        </div>
      </PageContainer>
    </>
  );
}
